import React from "react";

/** Small Cloud Mist pill label used above section headlines in Stitch. */
const SectionBadge = ({ children, className = "" }) => (
  <span
    className={`inline-block bg-cloud-mist text-spectrum-blue text-xs font-bold tracking-wider px-3.5 py-1 rounded-brand mb-3 ${className}`.trim()}
  >
    {children}
  </span>
);

export default SectionBadge;
